/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/12/cart-white': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<g class="nc-icon-wrapper" _fill="#fff"><path pid="0" d="M1 10.5A1.5 1.5 0 002.5 12h7a1.5 1.5 0 001.5-1.5V7H1z"/><path pid="1" d="M9.838 4L8.171.665a.75.75 0 00-1.342.67L8.162 4H3.838l1.333-2.665a.75.75 0 00-1.342-.67L2.162 4H0v2h12V4z" data-color="color-2"/></g>'
  }
})
